import {
    ACTIVITY_MASTERY,
    SELECTED_CLASS,
    SELECTED_GROUP,
    SELECTED_STUDENT,
    SELECTED_REPORT,
    SELECTED_DATE,
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER,
    ALL_YEARS,
    ALL_TEACHERS,
    ALL_CLASSES,
    ALL_GROUPS,
    ALL_STUDENTS
} from '../../filter-constants';
import {
    SET_ACTIVE_FILTERS,
    UPDATE_ACTIVE_FILTER
} from './active-filters-actions';
import DateParamHelper from '../../../../helpers/date-param-helper';

const initialDate = DateParamHelper.getInitialDate();

export const defaultState = {
    [SELECTED_YEAR_GROUP]: { id: ALL_YEARS, name: ALL_YEARS },
    [SELECTED_TEACHER]: { id: ALL_TEACHERS, name: ALL_TEACHERS },
    [SELECTED_CLASS]: { id: ALL_CLASSES, name: ALL_CLASSES },
    [SELECTED_GROUP]: { id: ALL_GROUPS, name: ALL_GROUPS },
    [SELECTED_STUDENT]: { id: ALL_STUDENTS, name: ALL_STUDENTS },
    [SELECTED_REPORT]: { id: ACTIVITY_MASTERY, name: ACTIVITY_MASTERY },
    [SELECTED_DATE]: initialDate
};

export const initialState = () => ({
    [SELECTED_YEAR_GROUP]: { id: null, name: null },
    [SELECTED_TEACHER]: { id: null, name: null },
    [SELECTED_CLASS]: { id: null, name: null },
    [SELECTED_GROUP]: { id: null, name: null },
    [SELECTED_STUDENT]: { id: null, name: null },
    [SELECTED_REPORT]: { id: null, name: null },
    [SELECTED_DATE]: { type: null, startDate: null, endDate: null }
});

/**
 * Active Filters Reducer
 *
 * Consumes SET_ACTIVE_FILTERS action
 * Consumes UPDATE_ACTIVE_FILTER action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current active filters
 */
export default function(state = initialState(), action) {
    if (!action) return state;

    switch (action.type) {
        case SET_ACTIVE_FILTERS:
            return {
                ...state,
                ...action.payload
            };
        case UPDATE_ACTIVE_FILTER:
            return {
                ...state,
                [action.payload.filterName]: action.payload.filterValue
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/active-filters/active-filters-reducer.js